export default __webpack_public_path__ + "static/media/logo-.97a0f388.jpg";